import styled from 'styled-components';

export const DesktopWrapper = styled.div`
  width: 1094px;
  background-color: ${({ theme }) => theme.COLORS.BASE};
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  position: absolute;
  left: 50%;
  margin-top: 42px;
  transform: translate(-50%, 0);
`;

export const DesktopFooter = styled.div`
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
  max-width: 234px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.COLORS.NEUTRAL_80};
`;

export const DesktopMapTitle = styled.div`
  padding-top: 24px;
  padding-left: 24px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-size: ${({ theme }) => theme.FONT_SIZES.XLARGE};
`;
